module.exports = __webpack_public_path__ + "img/ic_contentitem_workout.acb72696.svg";